module.exports = __webpack_public_path__ + "assets/from_computer.8df96ac0.svg";